export const getLeadTypeLabel = (lead_type) => {
  switch (lead_type) {
    case 1:
      return "یوزر جدید";
    case 2:
      return "لید تمدیدی";
    default:
      return "نامشخص";
  }
};
